import { ChevronDownIcon, ChevronUpIcon, LockIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Thead,
  Tr,
  useMediaQuery,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { ArrowLeft, ArrowRight } from "react-feather";
import {
  getActualValues,
  getBalanceSheetOverview,
  getCashMovement,
  getForecasts,
  getSubAccounts,
  getTransactionBreakdown,
  getVendorBreakdown,
  getYtdAverages,
} from "../../api/detail";
import { useCurrentProfile } from "../../ContextWrapper";
import { customCurrencyFormat } from "../../utils";
import YtdToggle from "../dashboardComponents/ytdToggle";
import Scrollbar from "../generic/scrollBar";
import HorizontalScrollbar from "../generic/scrollBarX";
import NotificationContainer from "../generic/updateNotification";
import UncategorizedNotificationBanner from "../uncategorized/uncategorizedNotificationBanner";

export const LowerDetailRow = ({
  name = "-",
  forecast = 0,
  actual = 0,
  ytdAverage = 0,
  bracket = false,
  invert = false,
  ytd = false,
  ytdValue = 0,
}) => {
  return (
    <Tr>
      <Td backgroundColor={"#F6F8FE"} fontWeight={"bold"} p={"7px 20px"}>
        {name}
      </Td>
      {invert && (
        <Td
          textAlign="right"
          backgroundColor={"#F6F8FE"}
          fontWeight={"bold"}
          p={"7px 20px"}
        >
          {bracket
            ? actual
              ? `(${actual})`
              : `(${actual})`
            : actual
            ? `${actual}`
            : `${actual}`}
        </Td>
      )}
      <Td
        textAlign="right"
        backgroundColor={"#F6F8FE"}
        fontWeight={"bold"}
        p={"7px 20px"}
      >
        {bracket
          ? forecast
            ? `(${forecast})`
            : `(${forecast})`
          : forecast
          ? `${forecast}`
          : `${forecast}`}
      </Td>

      {!invert && (
        <Td
          textAlign="right"
          backgroundColor={"#F6F8FE"}
          fontWeight={"bold"}
          p={"7px 20px"}
        >
          {bracket
            ? actual
              ? `(${actual})`
              : `(${actual})`
            : actual
            ? `${actual}`
            : `${actual}`}
        </Td>
      )}
      {ytd && (
        <Td
          textAlign="right"
          backgroundColor={"#F6F8FE"}
          fontWeight={"bold"}
          p={"7px 20px"}
        >
          {bracket
            ? ytdValue
              ? `(${ytdValue})`
              : `(${ytdValue})`
            : ytdValue
            ? `${ytdValue}`
            : `${ytdValue}`}
        </Td>
      )}
      <Td
        textAlign="right"
        backgroundColor={"#F6F8FE"}
        fontWeight={"bold"}
        p={"7px 20px"}
      >
        {bracket
          ? ytdAverage
            ? `(${ytdAverage})`
            : `(${ytdAverage})`
          : ytdAverage
          ? `${ytdAverage}`
          : `${ytdAverage}`}
      </Td>
    </Tr>
  );
};

export const DetailRow = ({
  name = "-",
  forecast = 0,
  actual = 0,
  ytdAverage = 0,
  bracket = false,
  vendor = false,
  isOpen,
  expenseType,
  vendorExpenseSetter,
  titleSetter,
  vendorExpense,
  ytdEmpty = false,
  customer_id = null,
  date = null,
  setParams = null,
  activeRow,
  setActiveRow = null,
  margin = null,
  ytd = false,
  ytdValue = 0,
}) => {
  const [accountList, setAccountList] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);

  const adjusted = JSON.parse(
    sessionStorage.getItem("adjustedView") || "false"
  );

  const handleExpand = async () => {
    setActiveRow(activeRow === name ? "" : name);
    if (!hasFetched && vendor) {
      try {
        const res = await getSubAccounts(
          customer_id,
          date,
          vendorExpense,
          null,
          { adjusted }
        );
        setAccountList(res.data);
        setHasFetched(true);
      } catch (err) {
        console.error("Failed to fetch account list", err);
      }
    }
  };

  useEffect(() => {
    if (vendor || adjusted) {
      setHasFetched(false);
      setAccountList([]);
    }
  }, [customer_id, date, vendor, adjusted]);

  return (
    <>
      <Tr>
        <Td
          backgroundColor={activeRow === name ? "#536DEC" : "white"}
          p={"7px 20px"}
          textColor={activeRow === name ? "white" : "black"}
          onClick={!vendor ? undefined : handleExpand}
          cursor={!vendor ? "default" : "pointer"}
          _hover={
            !vendor
              ? undefined
              : activeRow === name
              ? {
                  color: "white",
                  fontWeight: "600",
                }
              : {
                  boxShadow: "inset 0 0 0 2px #536DEC",
                  color: "#536DEC",
                  fontWeight: "600",
                }
          }
        >
          <HStack>
            <Text ml={margin && margin}>{name}</Text> <Spacer />{" "}
            {vendor &&
              (activeRow === name ? (
                <ChevronUpIcon boxSize={"22px"} />
              ) : (
                <ChevronDownIcon boxSize={"22px"} />
              ))}
          </HStack>
        </Td>
        {!vendor ? (
          <Td textAlign="right" p={"7px 20px"}>
            {bracket ? `(${actual || 0})` : `${actual || 0}`}
          </Td>
        ) : (
          <Td
            cursor="pointer"
            _hover={
              activeRow === name
                ? {
                    color: "white",
                    fontWeight: "600",
                  }
                : {
                    boxShadow: "inset 0 0 0 2px #536DEC",
                    color: "#536DEC",
                    fontWeight: "600",
                  }
            }
            onClick={() => {
              isOpen(true);
              setParams({});
              titleSetter(name);
              vendorExpenseSetter(vendorExpense);
            }}
            backgroundColor={activeRow === name ? "#536DEC" : "white"}
            textColor={activeRow === name ? "white" : "black"}
            textAlign="right"
            p={"7px 20px"}
          >
            {bracket ? `(${actual || 0})` : `${actual || 0}`}
          </Td>
        )}
        <Td
          textAlign="right"
          backgroundColor={activeRow === name ? "#536DEC" : "white"}
          p={"7px 20px"}
          textColor={activeRow === name ? "white" : "black"}
        >
          {forecast !== null &&
            (bracket ? `(${forecast || 0})` : `${forecast || 0}`)}
        </Td>

        {ytd && (
          <Td
            textColor={activeRow === name ? "white" : "black"}
            backgroundColor={activeRow === name ? "#536DEC" : "white"}
            textAlign="right"
            p={"7px 20px"}
          >
            {ytdValue || 0}
          </Td>
        )}

        <Td
          textColor={activeRow === name ? "white" : "black"}
          backgroundColor={activeRow === name ? "#536DEC" : "white"}
          textAlign="right"
          p={"7px 20px"}
        >
          {!ytdEmpty
            ? bracket
              ? `(${ytdAverage || 0})`
              : `${ytdAverage || 0}`
            : ""}
        </Td>
      </Tr>

      {activeRow === name &&
        (accountList.filter(
          (account) =>
            account?.actual !== "0.00" && account?.ytdAverage !== "0.00"
        ).length > 0 ? (
          accountList.map(
            (account, index) =>
              (account?.actual !== "0.00" ||
                account?.ytdAverage !== "0.00") && (
                <Tr key={index} bg="#536DEC26">
                  <Td p={"7px 20px"}>
                    <Text ml={margin && margin}>{account?.name}</Text>
                  </Td>
                  <Td
                    textAlign="right"
                    p={"7px 20px"}
                    cursor={!vendor ? "default" : "pointer"}
                    _hover={
                      !vendor
                        ? undefined
                        : {
                            boxShadow: "inset 0 0 0 2px #536DEC",
                            color: "#536DEC",
                            fontWeight: "600",
                          }
                    }
                    onClick={() => {
                      isOpen(true);
                      setParams !== null &&
                        setParams({ accountNumber: account?.number });
                      titleSetter(account?.name);
                      vendorExpenseSetter(vendorExpense);
                    }}
                  >
                    {customCurrencyFormat(
                      account?.actual,
                      false,
                      true,
                      true,
                      false,
                      true
                    )}
                  </Td>
                  <Td textAlign="right" />

                  <Td
                    textAlign="right"
                    p={"7px 20px"}
                    cursor={!vendor ? "default" : "pointer"}
                    _hover={
                      !vendor
                        ? undefined
                        : {
                            boxShadow: "inset 0 0 0 2px #536DEC",
                            color: "#536DEC",
                            fontWeight: "600",
                          }
                    }
                    onClick={() => {
                      isOpen(true);
                      setParams !== null &&
                        setParams({
                          accountNumber: account?.number,
                          ytd: true,
                        });
                      titleSetter(account?.name);
                      vendorExpenseSetter(vendorExpense);
                    }}
                  >
                    {customCurrencyFormat(
                      account?.ytdTotal,
                      false,
                      true,
                      true,
                      false,
                      true
                    )}
                  </Td>

                  <Td textAlign="right" p={"7px 20px"}>
                    {customCurrencyFormat(
                      account?.ytdAverage,
                      false,
                      true,
                      true,
                      false,
                      true
                    )}
                  </Td>
                </Tr>
              )
          )
        ) : (
          <Tr bg="#536DEC26">
            <Td colSpan={5} textAlign="center" p={"10px"}>
              No data available.
            </Td>
          </Tr>
        ))}
    </>
  );
};

export const PopulateCashTable = ({ data }) => {
  return (
    <Tbody>
      {data &&
        typeof data === "object" &&
        !Array.isArray(data) &&
        Object.keys(data).map((outerKey) =>
          Object.entries(data[outerKey]).map(([innerKey, value]) =>
            innerKey === "ratio" ? (
              <DetailRow
                key={"ratio"}
                name={"Expense Cover Ratio"}
                actual={customCurrencyFormat(
                  value.earliest_ratio,
                  false,
                  true,
                  false
                )}
                forecast={customCurrencyFormat(
                  value.latest_ratio,
                  false,
                  true,
                  false
                )}
                ytdEmpty={true}
              />
            ) : innerKey === "Total" ? (
              <LowerDetailRow
                key={innerKey}
                name={innerKey}
                forecast={customCurrencyFormat(
                  value.earliest_balance,
                  false,
                  true
                )}
                actual={customCurrencyFormat(value.latest_balance, false, true)}
                ytdAverage={customCurrencyFormat(
                  value.total_movement,
                  false,
                  true
                )}
              />
            ) : outerKey === "credit_cards" ? (
              <DetailRow
                key={innerKey}
                name={innerKey}
                actual={customCurrencyFormat(
                  value.earliest_balance,
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  value.latest_balance,
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  value.total_movement,
                  false,
                  true
                )}
              />
            ) : (
              <DetailRow
                key={innerKey}
                name={innerKey}
                actual={customCurrencyFormat(
                  value.earliest_balance,
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  value.latest_balance,
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  value.total_movement,
                  false,
                  true
                )}
              />
            )
          )
        )}
    </Tbody>
  );
};

const DetailView = ({
  customer_id,
  dashDate,
  isExport = false,
  customer_type = null,
}) => {
  const formattedDate = format(dashDate, "yyyy-MM-dd");
  const [activeRow, setActiveRow] = useState(null);
  const { profile } = useCurrentProfile();

  const [ytdData, setYtdData] = useState({
    income: "-",
    cogs: "-",
    gross_profit: "-",
    marketing: "-",
    team: "-",
    practice_costs: "-",
    overhead: "-",
    business_development: "-",
    expense: "-",
    profit: "-",
    profit_percentage: "-",
  });

  const [actualData, setActualData] = useState({
    income: "-",
    cogs: "-",
    gross_profit: "-",
    marketing: "-",
    team: "-",
    practice_costs: "-",
    overhead: "-",
    business_development: "-",
    expense: "-",
    profit: "-",
    profit_percentage: "-",
  });

  const [forecastData, setForecastData] = useState({
    income: "-",
    cogs: "-",
    gross_profit: "-",
    marketing: "-",
    team: "-",
    practice_costs: "-",
    overhead: "-",
    business_development: "-",
    expense: "-",
    profit: "-",
    profit_percentage: "-",
  });

  const [cashData, setCashData] = useState({
    "Bank Accounts": {},
    "Credit Cards": {},

    expense_cover_ratio: {
      ratio: {
        earliest_ratio: "-",
        latest_ratio: "-",
      },
    },
    total: {
      Total: {
        earliest_balance: "-",
        latest_balance: "-",
        total_movement: "-",
      },
    },
  });

  const [balanceSheetData, setBalanceSheetData] = useState({
    acc_recievable: "0.00",
    last_acc_recievable: "0.00",
    bank_accounts: "0.00",
    last_bank_accounts: "0.00",
    acc_payable: "0.00",
    last_acc_payable: "0.00",
    credit_cards: "0.00",
    last_credit_cards: "0.00",
    fixed_assets: "0.00",
    last_fixed_assets: "0.00",
    current_assets: "0.00",
    last_current_assets: "0.00",
    long_term_liabilities: "0.00",
    last_long_term_liabilities: "0.00",
    current_liabilities: "0.00",
    last_current_liabilities: "0.00",
    equity: "-",
    last_equity: "-",

    acc_recievable_movement: "0.00",
    bank_accounts_movement: "0.00",
    acc_payable_movement: "0.00",
    credit_cards_movement: "0.00",
    fixed_assets_movement: "0.00",
    current_assets_movement: "0.00",
    long_term_liabilities_movement: "0.00",
    current_liabilities_movement: "0.00",
    equity_movement: "-",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vendorExpense, setVendorExpense] = useState("");
  const [hasXOverflow, setHasXOverflow] = useState(false);
  const [scrollWidth, setScrollWidth] = useState(0);
  const [hasCashXOverflow, setHasCashXOverflow] = useState(false);
  const [scrollCashWidth, setScrollCashWidth] = useState(0);
  const [hasXBalanceOverflow, setHasBalanceXOverflow] = useState(false);
  const [scrollBalanceWidth, setScrollBalanceWidth] = useState(0);
  const [title, setTitle] = useState("");
  const contentRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const contentCashRef = useRef(null);
  const scrollContainerCashRef = useRef(null);
  const contentBalanceRef = useRef(null);
  const scrollContainerBalanceRef = useRef(null);
  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  const [params, setParams] = useState({});

  const [ytd, setYtd] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("ytd") || "false");
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const handler = () => {
      const ytd = JSON.parse(sessionStorage.getItem("ytd") || "false");
      setYtd(ytd);
    };

    window.addEventListener("ytd-changed", handler);
    return () => window.removeEventListener("ytd-changed", handler);
  }, []);

  const [customTarget, setCustomTarget] = useState(
    JSON.parse(localStorage.getItem("isCustomTarget") || "false")
  );

  useEffect(() => {
    const handleTargetTypeChange = (event) => {
      setCustomTarget(event.detail);
    };

    window.addEventListener("targetTypeChanged", handleTargetTypeChange);

    return () => {
      window.removeEventListener("targetTypeChanged", handleTargetTypeChange);
    };
  }, []);

  const adjusted = JSON.parse(
    sessionStorage.getItem("adjustedView") || "false"
  );

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;

    const refreshActualData = async (id) => {
      if (!id) return;
      try {
        const res = await getActualValues(
          id,
          formattedDate,
          controller.signal,
          { adjusted }
        );
        if (isActive) setActualData(res.data);
      } catch (err) {
        if (err?.response) console.log(err);
      }
    };

    refreshActualData(customer_id);

    return () => {
      isActive = false;
      controller.abort();
    };
  }, [customer_id, formattedDate, adjusted]);

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;

    const refreshYtdData = async (id) => {
      if (!id) return;
      try {
        const res = await getYtdAverages(id, formattedDate, controller.signal, {
          adjusted,
        });
        if (isActive) setYtdData(res.data);
      } catch (err) {
        if (err?.response) console.log(err);
      }
    };

    refreshYtdData(customer_id);

    return () => {
      isActive = false;
      controller.abort();
    };
  }, [customer_id, formattedDate, adjusted]);

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;

    const refreshForecastData = async (id) => {
      if (!id) return;
      try {
        const res = await getForecasts(id, formattedDate, controller.signal, {
          adjusted,
          ytd,
          customTarget,
        });
        if (isActive) setForecastData(res.data);
      } catch (err) {
        if (err?.response) console.log(err);
      }
    };

    refreshForecastData(customer_id);

    return () => {
      isActive = false;
      controller.abort();
    };
  }, [customer_id, formattedDate, adjusted, ytd, customTarget]);

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;

    const refreshCashData = async (id) => {
      if (id) {
        try {
          const res = await getCashMovement(
            id,
            formattedDate,
            controller.signal
          );
          if (isActive) {
            setCashData(res.data);
          }
        } catch (err) {
          if (err?.response) {
            console.log(err);
          }
        }
      }
    };

    refreshCashData(customer_id);

    return () => {
      isActive = false;
      controller.abort();
    };
  }, [customer_id, formattedDate]);

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;

    const refreshBalanceSheetData = async (id) => {
      if (id) {
        try {
          const res = await getBalanceSheetOverview(
            id,
            formattedDate,
            controller.signal
          );
          if (isActive) {
            setBalanceSheetData(res.data);
          }
        } catch (err) {
          if (err?.response) {
            console.log(err);
          }
        }
      }
    };

    refreshBalanceSheetData(customer_id);

    return () => {
      isActive = false;
      controller.abort();
    };
  }, [customer_id, formattedDate]);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current && scrollContainerRef.current) {
        const hasOverflowX =
          contentRef.current.scrollWidth > contentRef.current.clientWidth;
        setHasXOverflow(hasOverflowX);

        if (hasOverflowX) {
          const contentWidth = contentRef.current.scrollWidth;
          const visibleWidth = scrollContainerRef.current.clientWidth;

          const thumbWidth = (visibleWidth / contentWidth) * 100;
          setScrollWidth(thumbWidth);
        } else {
          setScrollWidth(0);
        }
      }
    };

    // MutationObserver to detect DOM changes
    const observer = new MutationObserver(() => {
      checkOverflow(); // Check for overflow when the DOM changes
    });

    if (contentRef.current) {
      observer.observe(contentRef.current, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener("resize", checkOverflow);

    checkOverflow();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [formattedDate]);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current && scrollContainerRef.current) {
        const hasOverflowX =
          contentRef.current.scrollWidth > contentRef.current.clientWidth;
        setHasXOverflow(hasOverflowX);

        if (hasOverflowX) {
          const contentWidth = contentRef.current.scrollWidth;
          const visibleWidth = scrollContainerRef.current.clientWidth;

          const thumbWidth = (visibleWidth / contentWidth) * 100;
          setScrollWidth(thumbWidth);
        } else {
          setScrollWidth(0);
        }
      }
    };

    // MutationObserver to detect DOM changes
    const observer = new MutationObserver(() => {
      checkOverflow(); // Check for overflow when the DOM changes
    });

    if (contentRef.current) {
      observer.observe(contentRef.current, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener("resize", checkOverflow);

    checkOverflow();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [formattedDate]);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentCashRef.current && scrollContainerCashRef.current) {
        const hasOverflowX =
          contentCashRef.current.scrollWidth >
          contentCashRef.current.clientWidth;
        setHasCashXOverflow(hasOverflowX);

        if (hasOverflowX) {
          const contentWidth = contentCashRef.current.scrollWidth;
          const visibleWidth = scrollContainerCashRef.current.clientWidth;

          const thumbWidth = (visibleWidth / contentWidth) * 100;
          setScrollCashWidth(thumbWidth);
        } else {
          setScrollCashWidth(0);
        }
      }
    };

    // MutationObserver to detect DOM changes
    const observer = new MutationObserver(() => {
      checkOverflow(); // Check for overflow when the DOM changes
    });

    if (contentCashRef.current) {
      observer.observe(contentCashRef.current, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener("resize", checkOverflow);

    checkOverflow();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [formattedDate]);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentBalanceRef.current && scrollContainerBalanceRef.current) {
        const hasOverflowX =
          contentBalanceRef.current.scrollWidth >
          contentBalanceRef.current.clientWidth;
        setHasBalanceXOverflow(hasOverflowX);

        if (hasOverflowX) {
          const contentWidth = contentBalanceRef.current.scrollWidth;
          const visibleWidth = scrollContainerBalanceRef.current.clientWidth;

          const thumbWidth = (visibleWidth / contentWidth) * 100;
          setScrollBalanceWidth(thumbWidth);
        } else {
          setScrollBalanceWidth(0);
        }
      }
    };

    // MutationObserver to detect DOM changes
    const observer = new MutationObserver(() => {
      checkOverflow(); // Check for overflow when the DOM changes
    });

    if (contentBalanceRef.current) {
      observer.observe(contentBalanceRef.current, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener("resize", checkOverflow);

    checkOverflow();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [formattedDate]);

  useEffect(() => {
    setActiveRow(null);
  }, [customer_id, formattedDate, adjusted]);

  const [isMobile] = useMediaQuery("(max-width: 1280px)", { ssr: false });

  return (
    <>
      {!isExport && (
        <VendorModal
          isOpen={isModalOpen}
          toggle={toggle}
          title={`${title} Summary`}
          formattedDate={formattedDate}
          expenseType={vendorExpense}
          id={customer_id}
          params={params}
        />
      )}
      <Stack
        fontFamily={"lato"}
        width="100%"
        bg="#F4F4F2"
        align="left"
        p={isExport ? "0px" : "20px 30px"}
        mt={isExport ? "0px" : isMobile ? "130px" : "75px"}
        overflowY={"auto"}
      >
        <NotificationContainer rounded={true} />
        {profile?.type === "client" && (
          <UncategorizedNotificationBanner customerId={customer_id} />
        )}

        <Stack p="18px 0px 0px 0px">
          <YtdToggle></YtdToggle>
        </Stack>
        <Stack pt={"10px"}>
          <ProfitLoss
            ytdAveragesData={ytdData?.averages}
            ytdData={ytdData?.totals}
            setIsModalOpen={setIsModalOpen}
            setVendorExpense={setVendorExpense}
            customer_id={customer_id}
            formattedDate={formattedDate}
            setParams={setParams}
            contentRef={contentRef}
            forecastData={forecastData}
            actualData={actualData}
            setActiveRow={setActiveRow}
            activeRow={activeRow}
            hasXOverflow={hasXOverflow}
            scrollWidth={scrollWidth}
            scrollContainerRef={scrollContainerRef}
            setTitle={setTitle}
          />
          <CashMovement
            cashData={cashData}
            contentCashRef={contentCashRef}
            scrollContainerCashRef={scrollContainerCashRef}
            hasCashXOverflow={hasCashXOverflow}
            scrollCashWidth={scrollCashWidth}
            isLocked={customer_type === "trial" ? true : false}
          />
          <BalanceSheet
            contentBalanceRef={contentBalanceRef}
            balanceSheetData={balanceSheetData}
            hasXBalanceOverflow={hasXBalanceOverflow}
            scrollContainerBalanceRef={scrollContainerBalanceRef}
            scrollBalanceWidth={scrollBalanceWidth}
            isLocked={customer_type === "trial" ? true : false}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default DetailView;

export const ProfitLoss = ({
  ytdData,
  ytdAveragesData,
  setIsModalOpen,
  setVendorExpense,
  customer_id,
  formattedDate,
  setParams,
  contentRef,
  forecastData,
  actualData,
  setActiveRow,
  activeRow,
  hasXOverflow,
  scrollWidth,
  scrollContainerRef,
  isExport = false,
  setTitle,
}) => {
  return (
    <Box>
      <Text fontSize={"22px"} p={"0px 0px 10px 15px"} fontWeight={800}>
        Profit & Loss Breakdown
      </Text>
      <TableContainer
        ref={contentRef}
        borderTopRadius="12px"
        borderBottomRadius={isExport ? 0 : "12px"}
        overflowX={"hidden"}
        width={isExport ? "714px" : "100%"}
        height="100%"
        bg={"white"}
      >
        <Table
          variant="unstyled"
          width={isExport ? "714px" : "100%"}
          sx={{
            borderCollapse: "separate",
            borderSpacing: 0,
            borderRadius: "12px",
            overflow: "hidden",
            tableLayout: isExport ? "fixed" : "auto",
            wordWrap: "break-word",

            thead: {
              "tr, th": {
                border: "none",
                borderRadius: 0,
              },
            },

            tbody: {
              tr: {
                td: {
                  borderTop: "1px solid #D1D4DA",
                  borderLeft: "1px solid #D1D4DA",
                  borderBottom: "none",
                },
                "&:first-of-type td:first-of-type": {
                  borderLeft: "1px solid #D1D4DA",
                },
                "&:first-of-type td:last-of-type": {
                  borderRight: "1px solid #D1D4DA",
                },
                "&:last-of-type": {
                  td: {
                    borderBottom: "1px solid #D1D4DA",
                  },
                  "td:first-of-type": {
                    borderBottomLeftRadius: "12px",
                    borderLeft: "1px solid #D1D4DA",
                  },
                  "td:last-of-type": {
                    borderBottomRightRadius: "12px",
                    borderRight: "1px solid #D1D4DA",
                  },
                },
                "td:last-of-type": {
                  borderRight: "1px solid #D1D4DA",
                },
              },
            },

            // Print-specific styles:
            "@media print": {
              borderCollapse: "collapse",
              borderSpacing: 0,
              borderRadius: 0,
              thead: {
                "tr, th": {
                  border: "none !important",
                  borderRadius: 0,
                  "-webkit-print-color-adjust": "exact",
                  "print-color-adjust": "exact",
                },
              },
              tbody: {
                tr: {
                  td: {
                    border: "1px solid #D1D4DA !important",
                    borderBottom: "none !important",
                    "-webkit-print-color-adjust": "exact",
                    "print-color-adjust": "exact",
                  },
                  "&:first-of-type td:first-of-type": {
                    borderLeft: "1px solid #D1D4DA !important",
                  },
                  "&:first-of-type td:last-of-type": {
                    borderRight: "1px solid #D1D4DA !important",
                  },
                  "&:last-of-type": {
                    td: {
                      borderBottom: "1px solid #D1D4DA !important",
                    },
                    "td:first-of-type": {
                      borderBottomLeftRadius: "0 !important",
                      borderLeft: "1px solid #D1D4DA !important",
                    },
                    "td:last-of-type": {
                      borderBottomRightRadius: "0 !important",
                      borderRight: "1px solid #D1D4DA !important",
                    },
                  },
                  "td:last-of-type": {
                    borderRight: "1px solid #D1D4DA !important",
                  },
                },
              },
            },
          }}
        >
          <colgroup>
            <col style={{ width: "28%" }} />
            <col style={{ width: "18%" }} />
            <col style={{ width: "18%" }} />
            <col style={{ width: "18%" }} />
            <col style={{ width: "18%" }} />
          </colgroup>
          <Thead
            position="sticky"
            top={-1}
            zIndex={1}
            borderRadius="12px"
            backgroundColor={"#1A202C"}
          >
            <Tr
              padding={"10px 0px"}
              backgroundColor={"#1A202C"}
              textColor={"white"}
              height={"52px"}
            >
              <Td fontSize={isExport ? "15px" : "18px"} p={"7px 20px"}>
                <Flex justifyContent="space-between" alignItems="center">
                  <Text textAlign={"left"} mr={4} fontWeight={700}>
                    {" "}
                    Category
                  </Text>
                </Flex>
              </Td>
              <Td
                fontSize={isExport ? "15px" : "18px"}
                p={"7px 20px"}
                textAlign={"right"}
              >
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                >
                  <Text
                    textAlign={"right"}
                    mr={!isExport && 4}
                    fontWeight={700}
                  >
                    Actual
                  </Text>
                </Flex>
              </Td>

              <Td
                fontSize={isExport ? "15px" : "18px"}
                p={"7px 20px"}
                textAlign={"right"}
              >
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                >
                  <Text
                    textAlign={"right"}
                    mr={!isExport && 4}
                    fontWeight={700}
                  >
                    Target
                  </Text>
                </Flex>
              </Td>
              <Td
                fontSize={isExport ? "15px" : "18px"}
                p={"7px 20px"}
                textAlign={"right"}
              >
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                >
                  <Text
                    textAlign={"right"}
                    mr={!isExport && 4}
                    fontWeight={700}
                  >
                    YTD Total
                  </Text>
                </Flex>
              </Td>
              <Td
                fontSize={isExport ? "15px" : "18px"}
                p={"7px 20px"}
                textAlign={"right"}
              >
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                >
                  <Text
                    textAlign={"right"}
                    mr={!isExport && 4}
                    fontWeight={700}
                  >
                    YTD Average
                  </Text>
                </Flex>
              </Td>
            </Tr>
          </Thead>
          <Tbody>
            <DetailRow
              name="Income"
              forecast={customCurrencyFormat(
                forecastData?.income_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.income ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.income ?? "-",
                false,
                true
              )}
              vendor={!isExport ? true : false}
              isOpen={setIsModalOpen}
              expenseType="Income"
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"income"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.income ?? "-",
                false,
                true
              )}
            />

            <DetailRow
              name="Products"
              forecast={customCurrencyFormat(
                forecastData?.cogs_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.cogs ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.cogs ?? "-",
                false,
                true
              )}
              vendor={!isExport ? true : false}
              isOpen={setIsModalOpen}
              expenseType="Cogs"
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"cogs"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(ytdData?.cogs ?? "-", false, true)}
            />

            <LowerDetailRow
              name="Gross Profit"
              forecast={customCurrencyFormat(
                forecastData?.gross_profit_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.gross_profit ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.gross_profit ?? "-",
                false,
                true
              )}
              invert={true}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.gross_profit ?? "-",
                false,
                true
              )}
            />
            <LowerDetailRow
              name="Gross Profit Margin"
              forecast={customCurrencyFormat(
                forecastData?.gross_profit_margin ?? "-",
                true
              )}
              actual={customCurrencyFormat(
                actualData?.gross_profit_margin ?? "-",
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.gross_profit_margin ?? "-",
                true
              )}
              invert={true}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.gross_profit_margin ?? "-",
                true
              )}
            />
            <DetailRow
              name="Team"
              forecast={customCurrencyFormat(
                forecastData?.team_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.team ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.team ?? "-",
                false,
                true
              )}
              vendor={!isExport ? true : false}
              isOpen={setIsModalOpen}
              expenseType="Team"
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"team"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(ytdData?.team ?? "-", false, true)}
            />
            <DetailRow
              name="Marketing"
              forecast={customCurrencyFormat(
                forecastData?.marketing_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.marketing ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.marketing ?? "-",
                false,
                true
              )}
              vendor={!isExport ? true : false}
              isOpen={setIsModalOpen}
              expenseType="Marketing"
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"marketing"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.marketing ?? "-",
                false,
                true
              )}
            />
            <DetailRow
              name="Operations"
              forecast={customCurrencyFormat(
                forecastData?.operations_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.operations ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.operations ?? "-",
                false,
                true
              )}
              vendor={false}
              isOpen={setIsModalOpen}
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"practiceCosts"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.operations ?? "-",
                false,
                true
              )}
            />
            <DetailRow
              name="Practice Costs"
              margin="10px"
              forecast={customCurrencyFormat(
                forecastData?.practice_cost_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.practice_costs ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.practice_costs ?? "-",
                false,
                true
              )}
              vendor={!isExport ? true : false}
              isOpen={setIsModalOpen}
              expenseType="Practice Costs"
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"practiceCosts"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.practice_costs ?? "-",
                false,
                true
              )}
            />
            <DetailRow
              name="Overhead"
              margin="10px"
              forecast={customCurrencyFormat(
                forecastData?.overhead_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.overhead ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.overhead ?? "-",
                false,
                true
              )}
              vendor={!isExport ? true : false}
              isOpen={setIsModalOpen}
              expenseType="Overheads"
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"overheads"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.overhead ?? "-",
                false,
                true
              )}
            />
            <DetailRow
              name="Business Development"
              margin="10px"
              forecast={customCurrencyFormat(
                forecastData?.business_development_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.business_development ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.business_development ?? "-",
                false,
                true
              )}
              vendor={!isExport ? true : false}
              isOpen={setIsModalOpen}
              expenseType="Business Development"
              vendorExpenseSetter={setVendorExpense}
              vendorExpense={"businessDevelopment"}
              customer_id={customer_id}
              date={formattedDate}
              setParams={setParams}
              setActiveRow={setActiveRow}
              activeRow={activeRow}
              titleSetter={setTitle}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.business_development ?? "-",
                false,
                true
              )}
            />
            {((forecastData?.taxes_forecast !== "0.00" &&
              forecastData?.taxes_forecast != null) ||
              (actualData?.taxes !== "0.00" && actualData?.taxes != null) ||
              (ytdData?.taxes !== "0.00" && ytdData?.taxes != null)) && (
              <DetailRow
                name="Taxes"
                forecast={customCurrencyFormat(
                  forecastData?.taxes_forecast ?? "-",
                  false,
                  true
                )}
                actual={customCurrencyFormat(
                  actualData?.taxes ?? "-",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  ytdAveragesData?.taxes ?? "-",
                  false,
                  true
                )}
                vendor={!isExport ? true : false}
                isOpen={setIsModalOpen}
                expenseType="Taxes"
                vendorExpenseSetter={setVendorExpense}
                vendorExpense={"taxes"}
                customer_id={customer_id}
                date={formattedDate}
                setParams={setParams}
                setActiveRow={setActiveRow}
                activeRow={activeRow}
                titleSetter={setTitle}
                ytd={true}
                ytdValue={customCurrencyFormat(
                  ytdData?.taxes ?? "-",
                  false,
                  true
                )}
              />
            )}
            <LowerDetailRow
              name="Total Expenses"
              forecast={customCurrencyFormat(
                forecastData?.expense_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.expense ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.expense ?? "-",
                false,
                true
              )}
              invert={true}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.expense ?? "-",
                false,
                true
              )}
            />
            <LowerDetailRow
              name="Net Operating Income"
              forecast={customCurrencyFormat(
                forecastData?.net_operating_profit_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.operating_income ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.operating_income ?? "-",
                false,
                true
              )}
              invert={true}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.operating_income ?? "-",
                false,
                true
              )}
            />
            {((actualData?.other_income !== "0.00" &&
              actualData?.other_income != null) ||
              (ytdData?.other_income !== "0.00" &&
                ytdData?.other_income != null)) && (
              <DetailRow
                name="Other Income"
                forecast={null}
                actual={customCurrencyFormat(
                  actualData?.other_income ?? "-",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  ytdAveragesData?.other_income ?? "-",
                  false,
                  true
                )}
                vendor={!isExport ? true : false}
                isOpen={setIsModalOpen}
                expenseType="Other Income"
                vendorExpenseSetter={setVendorExpense}
                vendorExpense={"otherIncome"}
                customer_id={customer_id}
                date={formattedDate}
                setParams={setParams}
                setActiveRow={setActiveRow}
                activeRow={activeRow}
                titleSetter={setTitle}
                ytd={true}
                ytdValue={customCurrencyFormat(
                  ytdData?.other_income ?? "-",
                  false,
                  true
                )}
              />
            )}
            {((actualData?.other_expense !== "0.00" &&
              actualData?.other_expense != null) ||
              (ytdData?.other_expense !== "0.00" &&
                ytdData?.other_expense != null)) && (
              <DetailRow
                name="Other Expenses"
                forecast={null}
                actual={customCurrencyFormat(
                  actualData?.other_expense ?? "-",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  ytdAveragesData?.other_expense ?? "-",
                  false,
                  true
                )}
                vendor={!isExport ? true : false}
                isOpen={setIsModalOpen}
                expenseType="Other Expenses"
                vendorExpenseSetter={setVendorExpense}
                vendorExpense={"otherExpense"}
                customer_id={customer_id}
                date={formattedDate}
                setParams={setParams}
                setActiveRow={setActiveRow}
                activeRow={activeRow}
                titleSetter={setTitle}
                ytd={true}
                ytdValue={customCurrencyFormat(
                  ytdData?.other_expense ?? "-",
                  false,
                  true
                )}
              />
            )}
            <LowerDetailRow
              name="Net Operating Profit"
              forecast={customCurrencyFormat(
                forecastData?.net_operating_profit_forecast ?? "-",
                false,
                true
              )}
              actual={customCurrencyFormat(
                actualData?.profit ?? "-",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.profit ?? "-",
                false,
                true
              )}
              invert={true}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.profit ?? "-",
                false,
                true
              )}
            />
            <DetailRow
              name="Net Profit Margin"
              forecast={customCurrencyFormat(
                forecastData?.net_profit_margin_forecast ?? "-",
                true
              )}
              actual={customCurrencyFormat(
                actualData?.profit_percentage ?? "-",
                true
              )}
              ytdAverage={customCurrencyFormat(
                ytdAveragesData?.profit_percentage ?? "-",
                true
              )}
              ytd={true}
              ytdValue={customCurrencyFormat(
                ytdData?.profit_percentage ?? "-",
                true
              )}
            />
          </Tbody>
        </Table>
      </TableContainer>
      <Box
        position={"relative"}
        width={"100%"}
        marginTop={"10px"}
        ref={scrollContainerRef}
      >
        {hasXOverflow ? (
          <HorizontalScrollbar
            targetRef={contentRef}
            sx={{
              position: "absolute",
              right: 0, // Align to the right
              top: 0,
              width: "100%",
              height: "100%",
              visibility: hasXOverflow ? "visible" : "hidden",
              "&::-webkit-scrollbar-thumb": {
                width: `${scrollWidth}%`,
                visibility: hasXOverflow ? "visible" : "hidden",
              },
              "&::-webkit-scrollbar-track": {
                visibility: hasXOverflow ? "visible" : "hidden",
              },
            }}
          />
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export const CashMovement = ({
  contentCashRef,
  cashData,
  scrollContainerCashRef,
  scrollCashWidth,
  hasCashXOverflow,
  isExport = false,
  isLocked,
}) => {
  return (
    <Box>
      <Text fontSize={"22px"} fontWeight={800} p={"0px 0px 10px 15px"}>
        Cash Movement
      </Text>

      <TableContainer
        ref={contentCashRef}
        borderTopRadius="12px"
        borderBottomRadius={isExport ? 0 : "12px"}
        overflowX={"hidden"}
        width="100%"
        height="100%"
        bg={"white"}
        position="relative"
      >
        {isLocked && (
          <Box
            position="absolute"
            top={0}
            left={0}
            w="100%"
            h="100%"
            bg="rgba(255, 255, 255, 0.7)"
            backdropFilter="blur(5px)"
            zIndex={10}
            display="flex"
            flexDir={"column"}
            alignItems="center"
            justifyContent="center"
          >
            <LockIcon></LockIcon>
            <Text
              fontWeight={700}
              fontSize="lg"
              color="gray.700"
              p={2}
              textAlign={"center"}
            >
              Upgrade to Unlock Cash Movement
            </Text>
          </Box>
        )}
        <Table
          variant="unstyled"
          sx={{
            borderCollapse: "separate",
            borderSpacing: 0,
            borderRadius: "12px",
            overflow: "hidden",
            width: "100%",

            thead: {
              "tr, th": {
                border: "none",
                borderRadius: 0,
              },
            },

            tbody: {
              tr: {
                td: {
                  borderTop: "1px solid #D1D4DA",
                  borderLeft: "1px solid #D1D4DA",
                  borderBottom: "none",
                },
                "&:first-of-type td:first-of-type": {
                  borderLeft: "1px solid #D1D4DA",
                },
                "&:first-of-type td:last-of-type": {
                  borderRight: "1px solid #D1D4DA",
                },
                "&:last-of-type": {
                  td: {
                    borderBottom: "1px solid #D1D4DA",
                  },
                  "td:first-of-type": {
                    borderBottomLeftRadius: "12px",
                    borderLeft: "1px solid #D1D4DA",
                  },
                  "td:last-of-type": {
                    borderBottomRightRadius: "12px",
                    borderRight: "1px solid #D1D4DA",
                  },
                },
                "td:last-of-type": {
                  borderRight: "1px solid #D1D4DA",
                },
              },
            },

            // Print-specific styles:
            "@media print": {
              borderCollapse: "collapse",
              borderSpacing: 0,
              borderRadius: 0,
              thead: {
                "tr, th": {
                  border: "none !important",
                  borderRadius: 0,
                  "-webkit-print-color-adjust": "exact",
                  "print-color-adjust": "exact",
                },
              },
              tbody: {
                tr: {
                  td: {
                    border: "1px solid #D1D4DA !important",
                    borderBottom: "none !important",
                    "-webkit-print-color-adjust": "exact",
                    "print-color-adjust": "exact",
                  },
                  "&:first-of-type td:first-of-type": {
                    borderLeft: "1px solid #D1D4DA !important",
                  },
                  "&:first-of-type td:last-of-type": {
                    borderRight: "1px solid #D1D4DA !important",
                  },
                  "&:last-of-type": {
                    td: {
                      borderBottom: "1px solid #D1D4DA !important",
                    },
                    "td:first-of-type": {
                      borderBottomLeftRadius: "0 !important",
                      borderLeft: "1px solid #D1D4DA !important",
                    },
                    "td:last-of-type": {
                      borderBottomRightRadius: "0 !important",
                      borderRight: "1px solid #D1D4DA !important",
                    },
                  },
                  "td:last-of-type": {
                    borderRight: "1px solid #D1D4DA !important",
                  },
                },
              },
            },
          }}
        >
          <Thead borderRadius="12px" backgroundColor={"#1A202C"}>
            <Tr
              padding={"10px 0px"}
              backgroundColor={"#1A202C"}
              textColor={"white"}
            >
              <Td fontSize={isExport ? "15px" : "18px"} fontWeight={700}>
                <Flex justifyContent="space-between" alignItems="center">
                  <Text textAlign={"left"} mr={4}>
                    Account
                  </Text>
                </Flex>
              </Td>
              <Td
                fontSize={isExport ? "15px" : "18px"}
                p={isExport && "10px 20px"}
                fontWeight={700}
              >
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                >
                  {isExport ? (
                    <Box>
                      <Text
                        textAlign={!isExport ? "left" : "center"}
                        mr={!isExport && 4}
                      >
                        Start of Month
                      </Text>
                      <Text>Balance</Text>
                    </Box>
                  ) : (
                    <Text
                      textAlign={!isExport ? "left" : "center"}
                      mr={!isExport && 4}
                    >
                      Start of Month Balance
                    </Text>
                  )}
                </Flex>
              </Td>
              <Td
                fontSize={isExport ? "15px" : "18px"}
                p={isExport && "10px 20px"}
                fontWeight={700}
              >
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                >
                  {isExport ? (
                    <Box>
                      <Text
                        textAlign={!isExport ? "left" : "center"}
                        mr={!isExport && 4}
                      >
                        End of Month
                      </Text>
                      <Text>Balance</Text>
                    </Box>
                  ) : (
                    <Text
                      textAlign={!isExport ? "left" : "center"}
                      mr={!isExport && 4}
                    >
                      End of Month Balance
                    </Text>
                  )}
                </Flex>
              </Td>
              <Td
                fontSize={isExport ? "15px" : "18px"}
                p={isExport && "10px 20px"}
                fontWeight={700}
              >
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                >
                  {isExport ? (
                    <Box>
                      <Text
                        textAlign={!isExport ? "left" : "left"}
                        mr={!isExport && 4}
                      >
                        Total
                      </Text>
                      <Text>Movement</Text>
                    </Box>
                  ) : (
                    <Text
                      textAlign={!isExport ? "left" : "center"}
                      mr={!isExport && 4}
                    >
                      Total Movement
                    </Text>
                  )}
                </Flex>
              </Td>
            </Tr>
          </Thead>
          <PopulateCashTable data={cashData} />
        </Table>
      </TableContainer>

      {!isLocked && (
        <Box
          position={"relative"}
          width={"100%"}
          marginTop={"20px"}
          ref={scrollContainerCashRef}
        >
          {hasCashXOverflow ? (
            <HorizontalScrollbar
              targetRef={contentCashRef}
              sx={{
                position: "absolute",
                right: 0, // Align to the right
                top: 0,
                width: "100%",
                height: "100%",
                visibility: hasCashXOverflow ? "visible" : "hidden",
                "&::-webkit-scrollbar-thumb": {
                  width: `${scrollCashWidth}%`,
                  visibility: hasCashXOverflow ? "visible" : "hidden",
                },
                "&::-webkit-scrollbar-track": {
                  visibility: hasCashXOverflow ? "visible" : "hidden",
                },
              }}
            />
          ) : (
            <></>
          )}
        </Box>
      )}
    </Box>
  );
};

export const BalanceSheet = ({
  contentBalanceRef,
  balanceSheetData,
  hasXBalanceOverflow,
  scrollContainerBalanceRef,
  scrollBalanceWidth,
  isExport = false,
  isLocked,
}) => {
  return (
    <Box>
      <Text fontSize={"22px"} p={"0px 0px 10px 15px"} fontWeight={800}>
        Balance Sheet Overview
      </Text>

      <TableContainer
        ref={contentBalanceRef}
        borderTopRadius="12px"
        borderBottomRadius={isExport ? 0 : "12px"}
        overflowX={"hidden"}
        width="100%"
        height="100%"
        bg={"white"}
        position="relative"
      >
        {isLocked && (
          <Box
            position="absolute"
            top={0}
            left={0}
            w="100%"
            h="100%"
            bg="rgba(255, 255, 255, 0.7)"
            backdropFilter="blur(5px)"
            zIndex={10}
            display="flex"
            flexDir={"column"}
            alignItems="center"
            justifyContent="center"
          >
            <LockIcon></LockIcon>
            <Text
              fontWeight={700}
              fontSize="lg"
              color="gray.700"
              p={2}
              textAlign={"center"}
            >
              Upgrade to Unlock Balance Sheet Overview
            </Text>
          </Box>
        )}
        <Table
          variant="unstyled"
          sx={{
            borderCollapse: "separate",
            borderSpacing: 0,
            borderRadius: "12px",
            overflow: "hidden",
            width: "100%",

            thead: {
              "tr, th": {
                border: "none",
                borderRadius: 0,
              },
            },

            tbody: {
              tr: {
                td: {
                  borderTop: "1px solid #D1D4DA",
                  borderLeft: "1px solid #D1D4DA",
                  borderBottom: "none",
                },
                "&:first-of-type td:first-of-type": {
                  borderLeft: "1px solid #D1D4DA",
                },
                "&:first-of-type td:last-of-type": {
                  borderRight: "1px solid #D1D4DA",
                },
                "&:last-of-type": {
                  td: {
                    borderBottom: "1px solid #D1D4DA",
                  },
                  "td:first-of-type": {
                    borderBottomLeftRadius: "12px",
                    borderLeft: "1px solid #D1D4DA",
                  },
                  "td:last-of-type": {
                    borderBottomRightRadius: "12px",
                    borderRight: "1px solid #D1D4DA",
                  },
                },
                "td:last-of-type": {
                  borderRight: "1px solid #D1D4DA",
                },
              },
            },

            // Print-specific styles:
            "@media print": {
              borderCollapse: "collapse",
              borderSpacing: 0,
              borderRadius: 0,
              thead: {
                "tr, th": {
                  border: "none !important",
                  borderRadius: 0,
                  "-webkit-print-color-adjust": "exact",
                  "print-color-adjust": "exact",
                },
              },
              tbody: {
                tr: {
                  td: {
                    border: "1px solid #D1D4DA !important",
                    borderBottom: "none !important",
                    "-webkit-print-color-adjust": "exact",
                    "print-color-adjust": "exact",
                  },
                  "&:first-of-type td:first-of-type": {
                    borderLeft: "1px solid #D1D4DA !important",
                  },
                  "&:first-of-type td:last-of-type": {
                    borderRight: "1px solid #D1D4DA !important",
                  },
                  "&:last-of-type": {
                    td: {
                      borderBottom: "1px solid #D1D4DA !important",
                    },
                    "td:first-of-type": {
                      borderBottomLeftRadius: "0 !important",
                      borderLeft: "1px solid #D1D4DA !important",
                    },
                    "td:last-of-type": {
                      borderBottomRightRadius: "0 !important",
                      borderRight: "1px solid #D1D4DA !important",
                    },
                  },
                  "td:last-of-type": {
                    borderRight: "1px solid #D1D4DA !important",
                  },
                },
              },
            },
          }}
        >
          <Thead borderRadius="12px">
            <Tr
              padding={"16px 0px"}
              backgroundColor={"#1A202C"}
              textColor={"white"}
              height={"52px"}
            >
              <Td fontSize={isExport ? "15px" : "18px"} p={"7px 20px"}>
                <Flex
                  height={"20px"}
                  justifyContent="space-between"
                  alignItems="center"
                  fontWeight={700}
                >
                  <Text textAlign={"left"} mr={!isExport && 4}>
                    {" "}
                    Category
                  </Text>
                </Flex>
              </Td>
              <Td fontSize={isExport ? "15px" : "18px"} p={"7px 20px"}>
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                  fontWeight={700}
                  height={"20px"}
                >
                  <Text textAlign={"right"} mr={!isExport && 4}>
                    Previous Month
                  </Text>
                </Flex>
              </Td>
              <Td fontSize={isExport ? "15px" : "18px"} p={"7px 20px"}>
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                  fontWeight={700}
                  height={"20px"}
                >
                  <Text textAlign={"right"} mr={!isExport && 4}>
                    Current Month
                  </Text>
                </Flex>
              </Td>
              <Td fontSize={isExport ? "15px" : "18px"} p={"7px 20px"}>
                <Flex
                  justifyContent={!isExport ? "space-between" : "flex-end"}
                  alignItems="center"
                  fontWeight={700}
                  height={"20px"}
                >
                  <Text textAlign={"right"} mr={!isExport && 4}>
                    Movement
                  </Text>
                </Flex>
              </Td>
            </Tr>
          </Thead>
          <Tbody>
            {((balanceSheetData?.last_acc_recievable !== "0.00" &&
              balanceSheetData?.last_acc_recievable != null) ||
              (balanceSheetData?.acc_recievable !== "0.00" &&
                balanceSheetData?.acc_recievable != null)) && (
              <DetailRow
                name="Accounts Recievable"
                actual={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.last_acc_recievable : 0,
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.acc_recievable : 0,
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.acc_recievable_movement
                    : 0,
                  false,
                  true
                )}
              />
            )}
            {((balanceSheetData?.last_bank_accounts !== "0.00" &&
              balanceSheetData?.last_bank_accounts != null) ||
              (balanceSheetData?.bank_accounts !== "0.00" &&
                balanceSheetData?.bank_accounts != null)) && (
              <DetailRow
                name="Bank Accounts"
                actual={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.last_bank_accounts
                    : "0.00",
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.bank_accounts : "0.00",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.bank_accounts_movement
                    : "0.00",
                  false,
                  true
                )}
              />
            )}
            {((balanceSheetData?.last_acc_payable !== "0.00" &&
              balanceSheetData?.last_acc_payable != null) ||
              (balanceSheetData?.acc_payable !== "0.00" &&
                balanceSheetData?.acc_payable != null)) && (
              <DetailRow
                name="Accounts Payable"
                actual={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.last_acc_payable : "0.00",
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.acc_payable : "0.00",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.acc_payable_movement
                    : "0.00",
                  false,
                  true
                )}
              />
            )}
            {((balanceSheetData?.last_credit_cards !== "0.00" &&
              balanceSheetData?.last_credit_cards != null) ||
              (balanceSheetData?.credit_cards !== "0.00" &&
                balanceSheetData?.credit_cards != null)) && (
              <DetailRow
                name="Credit Cards"
                actual={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.last_credit_cards
                    : "0.00",
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.credit_cards : "0.00",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.credit_cards_movement
                    : "0.00",
                  false,
                  true
                )}
              />
            )}
            {((balanceSheetData?.last_fixed_assets !== "0.00" &&
              balanceSheetData?.last_fixed_assets != null) ||
              (balanceSheetData?.fixed_assets !== "0.00" &&
                balanceSheetData?.fixed_assets != null)) && (
              <DetailRow
                name="Fixed Assets"
                actual={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.last_fixed_assets
                    : "0.00",
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.fixed_assets : "0.00",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.fixed_assets_movement
                    : "0.00",
                  false,
                  true
                )}
              />
            )}
            {((balanceSheetData?.last_current_assets !== "0.00" &&
              balanceSheetData?.last_current_assets != null) ||
              (balanceSheetData?.current_assets !== "0.00" &&
                balanceSheetData?.current_assets != null)) && (
              <DetailRow
                name="Current Assets"
                actual={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.last_current_assets
                    : "0.00",
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData ? balanceSheetData.current_assets : "0.00",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.current_assets_movement
                    : "0.00",
                  false,
                  true
                )}
              />
            )}
            {((balanceSheetData?.last_long_term_liabilities !== "0.00" &&
              balanceSheetData?.last_long_term_liabilities != null) ||
              (balanceSheetData?.long_term_liabilities !== "0.00" &&
                balanceSheetData?.long_term_liabilities != null)) && (
              <DetailRow
                name="Long-Term Liabilities"
                actual={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.last_long_term_liabilities
                    : "0.00",
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.long_term_liabilities
                    : "0.00",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.long_term_liabilities_movement
                    : "0.00",
                  false,
                  true
                )}
              />
            )}
            {((balanceSheetData?.last_current_liabilities !== "0.00" &&
              balanceSheetData?.last_current_liabilities != null) ||
              (balanceSheetData?.current_liabilities !== "0.00" &&
                balanceSheetData?.current_liabilities != null)) && (
              <DetailRow
                name="Current Liabilities"
                actual={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.last_current_liabilities
                    : "0.00",
                  false,
                  true
                )}
                forecast={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.current_liabilities
                    : "0.00",
                  false,
                  true
                )}
                ytdAverage={customCurrencyFormat(
                  balanceSheetData
                    ? balanceSheetData.current_liabilities_movement
                    : "0.00",
                  false,
                  true
                )}
              />
            )}
            <LowerDetailRow
              name="Equity"
              forecast={customCurrencyFormat(
                balanceSheetData ? balanceSheetData.last_equity : "0.00",
                false,
                true
              )}
              actual={customCurrencyFormat(
                balanceSheetData ? balanceSheetData.equity : "0.00",
                false,
                true
              )}
              ytdAverage={customCurrencyFormat(
                balanceSheetData ? balanceSheetData.equity_movement : "0.00",
                false,
                true
              )}
            />
          </Tbody>
        </Table>
      </TableContainer>

      {!isLocked && (
        <Box
          position={"relative"}
          width={"100%"}
          marginTop={"20px"}
          ref={scrollContainerBalanceRef}
        >
          {hasXBalanceOverflow ? (
            <HorizontalScrollbar
              targetRef={contentBalanceRef}
              sx={{
                position: "absolute",
                right: 0, // Align to the right
                top: 0,
                width: "100%",
                height: "100%",
                visibility: hasXBalanceOverflow ? "visible" : "hidden",
                "&::-webkit-scrollbar-thumb": {
                  width: `${scrollBalanceWidth}%`,
                  visibility: hasXBalanceOverflow ? "visible" : "hidden",
                },
                "&::-webkit-scrollbar-track": {
                  visibility: hasXBalanceOverflow ? "visible" : "hidden",
                },
              }}
            />
          ) : (
            <></>
          )}
        </Box>
      )}
    </Box>
  );
};

const VendorModal = ({
  isOpen,
  id,
  toggle,
  title,
  formattedDate,
  expenseType,
  params,
}) => {
  const contentRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [hasXOverflow, setHasXOverflow] = useState(false);
  const [scrollWidth, setScrollWidth] = useState(0);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [vendorData, setVendorData] = useState({});
  const [switchTable, setSwitchTable] = useState(false);
  const [transactionData, setTransactionData] = useState({});
  const [total, setTotal] = useState("");
  const [transactionTitle, setTransactionTital] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [prevPage, setPrevPage] = useState(null);
  const [nextPage, setNextPage] = useState(null);
  const [pageRange, setPageRange] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (isOpen) {
      setSwitchTable(false);
    }
  }, [isOpen]);

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;

    const refreshVendorData = async (id) => {
      if (id) {
        if (expenseType) {
          try {
            const res = await getVendorBreakdown(
              id,
              formattedDate,
              expenseType,
              params,
              controller.signal
            );
            if (isActive) {
              setVendorData(res.data);
            }
          } catch (err) {
            if (err?.response) {
              console.log(err);
            }
          }
        } else {
          setVendorData({});
        }
      } else {
        setVendorData({});
      }
    };

    refreshVendorData(id);

    return () => {
      isActive = false;
      controller.abort();
    };
  }, [id, formattedDate, expenseType, params]);

  const refreshTransactionData = async (vendorId, page = 1) => {
    try {
      const queryParams = {
        ...params,
        page,
      };

      const res = await getTransactionBreakdown(
        id,
        formattedDate,
        expenseType,
        vendorId,
        queryParams
      );

      setTransactionData(res.data);
      if (res.data?.next) {
        const nextUrlObj = new URL(res.data?.next);

        setNextPage(nextUrlObj.searchParams.get("page"));
      } else {
        setNextPage(null);
      }

      if (res.data?.previous) {
        const previousUrlObj = new URL(res.data?.previous);
        const previousPage = previousUrlObj.searchParams.get("page");
        setPrevPage(previousPage ? previousPage : 1);
      } else {
        setPrevPage(null);
      }

      if (res.data?.page_range) {
        setPageRange(res.data.page_range);
      }
      if (res.data?.page) {
        setCurrentPage(res.data.page);
      }
    } catch (err) {
      if (err?.response) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current) {
        const hasOverflowY =
          contentRef.current.scrollHeight > contentRef.current.clientHeight;
        setHasOverflow(hasOverflowY);

        if (hasOverflowY) {
          const contentHeight = contentRef.current.scrollHeight;
          const visibleHeight = contentRef.current.clientHeight;
          setScrollHeight((visibleHeight / contentHeight) * 100); // Set scrollbar thumb height as a percentage
        } else {
          setScrollHeight(0); // Reset thumb height if no overflow
        }
      }
    };

    checkOverflow();

    const observer = new MutationObserver(() => {
      checkOverflow();
    });

    if (contentRef.current) {
      observer.observe(contentRef.current, { childList: true, subtree: true });
    }

    window.addEventListener("resize", checkOverflow);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [vendorData]);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current && scrollContainerRef.current) {
        const hasOverflowX =
          contentRef.current.scrollWidth > contentRef.current.clientWidth;
        setHasXOverflow(hasOverflowX);

        if (hasOverflowX) {
          const contentWidth = contentRef.current.scrollWidth;
          const visibleWidth = scrollContainerRef.current.clientWidth;

          const thumbWidth = (visibleWidth / contentWidth) * 100;
          setScrollWidth(thumbWidth);
        } else {
          setScrollWidth(0);
        }
      }
    };

    // MutationObserver to detect DOM changes
    const observer = new MutationObserver(() => {
      checkOverflow(); // Check for overflow when the DOM changes
    });

    if (contentRef.current) {
      observer.observe(contentRef.current, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener("resize", checkOverflow);

    checkOverflow();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [formattedDate]);

  const [isMobile] = useMediaQuery("(max-width: 720px)", { ssr: false });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        toggle();
        setSwitchTable(false);
      }}
      position={"sticky"}
      scrollBehavior="inside"
      isCentered
      height="100vh"
    >
      <ModalOverlay overflowY={"hidden"} />
      <ModalContent
        borderRadius="12px"
        overflow="hidden"
        maxHeight={"90vh"}
        width="auto"
        maxWidth="unset"
        margin={20}
      >
        <ModalHeader
          p={"20px 20px 10px 20px"}
          fontSize={"20px"}
          fontWeight={"500"}
        >
          {!switchTable ? title : transactionTitle}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p="0px 20px 20px 20px">
          <Flex flexDirection={"column"} position="relative">
            <TableContainer
              ref={contentRef}
              height={"100%"}
              maxHeight="60vh"
              overflowY="auto"
              borderRadius="12px"
              position="relative"
              marginRight={hasOverflow ? "20px" : 0}
              overflowX={"auto"}
              sx={{
                "::-webkit-scrollbar": { display: "none" },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
              }}
            >
              {" "}
              {!switchTable && (
                <Table
                  variant="unstyled"
                  bg="white"
                  padding={0}
                  rounded={"12px"}
                >
                  <Thead position="sticky" top={0} zIndex={3} bg="#1A202C">
                    <Tr
                      fontSize="18px"
                      sx={{
                        "& td": {
                          color: "white",
                          fontWeight: "200",
                        },
                      }}
                    >
                      <Td>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Text
                            fontWeight={"700"}
                            fontSize={"16px"}
                            textAlign={"left"}
                            mr={4}
                          >
                            Vendor
                          </Text>
                        </Flex>
                      </Td>

                      <Td>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Text
                            fontWeight={"700"}
                            fontSize={"16px"}
                            textAlign={"left"}
                            mr={4}
                          >
                            Amount
                          </Text>
                        </Flex>
                      </Td>
                    </Tr>
                  </Thead>

                  <Tbody zIndex={1}>
                    {vendorData?.vendors?.length > 0 ? (
                      vendorData.vendors.map((vendor) => (
                        <Tr key={vendor.id} height={"40px"}>
                          <Td
                            border="1px solid #D1D4DA"
                            p={"10px 18px"}
                            minWidth={"200px"}
                          >
                            <HStack width="100%" spacing="2">
                              <Flex
                                align="center"
                                justify="center"
                                fontWeight="400"
                                fontSize="16px"
                                minWidth="0" // Allow the Flex to shrink as needed
                              >
                                <Text
                                  whiteSpace="nowrap"
                                  overflow="visible"
                                  textOverflow="clip"
                                >
                                  {vendor.name}
                                </Text>
                              </Flex>
                            </HStack>
                          </Td>
                          <Td
                            p={"16px 18px"}
                            border="1px solid #D1D4DA"
                            backgroundColor={"#F6F8FE"}
                            _hover={
                              vendor.id !== "uncategorized"
                                ? {
                                    boxShadow: "inset 0 0 0 2px #536DEC",
                                    color: "#536DEC",
                                    fontWeight: "600",
                                  }
                                : {}
                            }
                            cursor={
                              vendor.id !== "uncategorized"
                                ? "pointer"
                                : "default"
                            }
                            onClick={() => {
                              vendor.id !== "uncategorized" &&
                                setSwitchTable(true);
                              refreshTransactionData(vendor.id);
                              setTransactionTital(
                                `${vendor.name} Transactions`
                              );
                              setVendorId(vendor.id);
                              setTotal(
                                customCurrencyFormat(
                                  vendor.amount,
                                  false,
                                  true,
                                  true,
                                  true
                                )
                              );
                            }}
                          >
                            {customCurrencyFormat(
                              vendor.amount,
                              false,
                              true,
                              true,
                              true
                            )}
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr border="1px solid #D1D4DA" height={"20px"}>
                        <Td colSpan={2} textAlign="center">
                          No vendor data.
                        </Td>
                      </Tr>
                    )}
                  </Tbody>

                  <Tfoot position="sticky" bottom={0} zIndex={3} bg="#1A202C">
                    <Tr
                      fontSize="18px"
                      sx={{
                        "& td": {
                          color: "white",
                          fontWeight: "200",
                        },
                      }}
                    >
                      <Td>Total</Td>
                      <Td>
                        {customCurrencyFormat(
                          vendorData?.total ? vendorData.total : "0",
                          false,
                          true,
                          true,
                          true
                        )}
                      </Td>
                    </Tr>
                  </Tfoot>
                </Table>
              )}
              {switchTable && (
                <Table
                  variant="unstyled"
                  bg="white"
                  padding={0}
                  rounded={"12px"}
                >
                  <Thead position="sticky" top={0} zIndex={3} bg="#1A202C">
                    <Tr
                      fontSize="18px"
                      sx={{
                        "& td": {
                          color: "white",
                          fontWeight: "200",
                        },
                      }}
                    >
                      <Td>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Text
                            fontWeight={"700"}
                            fontSize={"16px"}
                            textAlign={"left"}
                            mr={4}
                          >
                            Account
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Text
                            fontWeight={"700"}
                            fontSize={"16px"}
                            textAlign={"left"}
                            mr={4}
                          >
                            Date
                          </Text>
                        </Flex>
                      </Td>

                      <Td>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Text
                            fontWeight={"700"}
                            fontSize={"16px"}
                            textAlign={"left"}
                            mr={4}
                          >
                            Description
                          </Text>
                        </Flex>
                      </Td>

                      <Td>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Text
                            fontWeight={"700"}
                            fontSize={"16px"}
                            textAlign={"left"}
                            mr={4}
                          >
                            Amount
                          </Text>
                        </Flex>
                      </Td>
                    </Tr>
                  </Thead>

                  <Tbody zIndex={1}>
                    {transactionData?.results?.entries?.length > 0 ? (
                      transactionData?.results?.entries?.map((entry) => (
                        <Tr key={entry?.id} height={"40px"}>
                          <Td
                            border="1px solid #D1D4DA"
                            p={"10px 18px"}
                            minWidth={"200px"}
                          >
                            <Text
                              whiteSpace="normal"
                              overflow="visible"
                              textOverflow="clip"
                            >
                              {entry?.contra_account_label}
                            </Text>
                          </Td>
                          <Td
                            border="1px solid #D1D4DA"
                            p={"10px 18px"}
                            minWidth={"200px"}
                          >
                            <Text
                              whiteSpace="nowrap"
                              overflow="visible"
                              textOverflow="clip"
                            >
                              {entry?.date}
                            </Text>
                          </Td>
                          <Td
                            border="1px solid #D1D4DA"
                            p={"10px 18px"}
                            minWidth={"200px"}
                          >
                            <Text
                              whiteSpace="normal"
                              overflow="visible"
                              textOverflow="clip"
                            >
                              {entry?.description}
                            </Text>
                          </Td>
                          <Td
                            p={"16px 18px"}
                            border="1px solid #D1D4DA"
                            backgroundColor={"#F6F8FE"}
                          >
                            {customCurrencyFormat(
                              entry?.amount,
                              false,
                              true,
                              true,
                              true
                            )}
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr border="1px solid #D1D4DA" height={"20px"}>
                        <Td colSpan={4} textAlign="center">
                          No transaction data.
                        </Td>
                      </Tr>
                    )}
                  </Tbody>

                  <Tfoot position="sticky" bottom={0} zIndex={3} bg="#1A202C">
                    <Tr
                      fontSize="18px"
                      sx={{
                        "& td": {
                          color: "white",
                          fontWeight: "200",
                        },
                      }}
                    >
                      <Td>Total</Td>
                      <Td></Td>
                      <Td></Td>
                      <Td>{total}</Td>
                    </Tr>
                  </Tfoot>
                </Table>
              )}
            </TableContainer>

            {hasOverflow ? (
              <Scrollbar
                targetRef={contentRef}
                sx={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  height: "100%",
                  visibility: hasOverflow ? "visible" : "hidden",
                  "&::-webkit-scrollbar-thumb": {
                    height: `${scrollHeight}%`,
                    visibility: hasOverflow ? "visible" : "hidden",
                  },
                  "&::-webkit-scrollbar-track": {
                    visibility: hasOverflow ? "visible" : "hidden",
                  },
                }}
              />
            ) : (
              <></>
            )}
          </Flex>
          <Box
            position={"relative"}
            width={"100%"}
            marginTop={hasXOverflow ? "20px" : 0}
            ref={scrollContainerRef}
          >
            {hasXOverflow ? (
              <HorizontalScrollbar
                targetRef={contentRef}
                sx={{
                  position: "absolute",
                  right: 0, // Align to the right
                  top: 0,
                  width: "100%",
                  height: "100%",
                  visibility: hasXOverflow ? "visible" : "hidden",
                  "&::-webkit-scrollbar-thumb": {
                    width: `${scrollWidth}%`,
                    visibility: hasXOverflow ? "visible" : "hidden",
                  },
                  "&::-webkit-scrollbar-track": {
                    visibility: hasXOverflow ? "visible" : "hidden",
                  },
                }}
              />
            ) : (
              <></>
            )}
          </Box>
          {switchTable === true && (nextPage || prevPage) && (
            <HStack
              pt={"10px"}
              spacing={!isMobile ? 3 : 0}
              justify="center"
              align="center"
            >
              <Button
                variant="unstyled"
                isDisabled={!prevPage}
                _disabled={{
                  cursor: "default",
                  opacity: 0.6,
                  pointerEvents: "none",
                }}
                cursor={!nextPage ? "default" : "pointer"}
                onClick={() => refreshTransactionData(vendorId, prevPage)}
              >
                <HStack>
                  {!isMobile && <ArrowLeft />}
                  <Text>Prev</Text>
                </HStack>
              </Button>
              {pageRange.map((item, idx) =>
                typeof item === "number" ? (
                  <Button
                    key={idx}
                    variant="unstyled"
                    onClick={() => refreshTransactionData(vendorId, item)}
                    textColor={item === currentPage ? "white" : "black"}
                    backgroundColor={item === currentPage ? "#536DEC" : "white"}
                    _hover={{ color: "#627CFB" }}
                  >
                    {item}
                  </Button>
                ) : (
                  <Text key={idx} color="black">
                    ...
                  </Text>
                )
              )}

              <Button
                variant="unstyled"
                isDisabled={!nextPage}
                _disabled={{
                  cursor: "default",
                  opacity: 0.6,
                  pointerEvents: "none",
                }}
                onClick={() => refreshTransactionData(vendorId, nextPage)}
              >
                <HStack>
                  <Text>Next</Text>
                  {!isMobile && <ArrowRight />}
                </HStack>
              </Button>
            </HStack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
